// extracted by mini-css-extract-plugin
export default {"iconWrapper":"SyncStatusCloud_iconWrapper__BplP5","syncSpinner":"SyncStatusCloud_syncSpinner__TAuGF"};